export default "__VITE_ASSET__CDXwHqv4__"